import { create } from 'zustand';
import { Specialist, SpecialistList } from '../../../models/Specialist';

interface IModel {
  specialistSelected: Specialist;
  setSpecialistSelected: (props: Specialist) => void;

  linkedSpecialist?: string;
  setLinkedSpecialist: (props?: string) => void;

  specialists: SpecialistList[];
  setSpecialists: (props: SpecialistList[]) => void;
}

export const useSpecialist = create<IModel>(set => ({
  specialistSelected: {} as Specialist,
  setSpecialistSelected: specialistSelected => set(() => ({ specialistSelected })),
  setLinkedSpecialist: linkedSpecialist => set(() => ({ linkedSpecialist })),
  specialists: [],
  setSpecialists: specialists => set(() => ({ specialists }))
}));
